import { badgeIds } from './constants';
import { BadgeId } from './types';

const badgeIdSet: Set<string> = new Set<string>(badgeIds);
export const isBadgeId = (s: string): s is BadgeId => badgeIdSet.has(s);
